// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";
import { Api } from "../../api";
import { throttle } from "../../common/Utils";
import { Product } from "../../common/interfaces/conversionworld/Product";
import { BodyBuilder } from "../../common/interfaces/conversionworld/BodyBuilder";

@Component({
  mixins: [template],
  components: {},
})
export class ConversionworldSearchLayer extends Vue {
  @Prop()
  public language!: string;

  @Prop()
  public country!: string;

  private searchQuery: string = "";

  private products: Product[] = [];
  private bodybuilders: BodyBuilder[] = [];
  private lastQueries: string[] = [];
  private isSearching: boolean = false;

  public focusInput() {
    (this.$refs["input"] as Vue).$el.querySelector("input")!.focus();
  }

  public onCloseMenu() {
    // @ts-ignore
    this.$parent.closeFlyout();
    this.$emit("close-menu");
  }

  public created() {
    let queries = localStorage.getItem("conversionworld.search.lastQueries");
    if (queries) {
      let parsedQueries = JSON.parse(queries);
      if (parsedQueries) {
        this.lastQueries = parsedQueries;
      }
    }
  }

  @Watch("searchQuery")
  public searchQueryWatcher(value) {
    // @ts-ignore
    this.onSearchQueryChangeThrottled(value);
  }

  private onSearchQueryChangeThrottled = throttle(
    this.onSearchQueryChange,
    750
  );

  public async onSearchQueryChange(value) {
    if (value === "") {
      this.products = [];
      this.bodybuilders = [];
    } else {
      this.isSearching = true;
      let result = await Promise.all([
        Api.conversionWorldService.getProducts(
          {
            page_id: this.$store.page.page!.id,
            query: value,
            branchen: [],
            solutions: [],
            countries: [],
            model_series: [],
            bodybuilder: [],
          },
          "both",
          1,
          3,
          true
        ),
        Api.conversionWorldService.getBodyBuilders(
          undefined,
          {
            query: value,
            page_id: this.$store.page.page!.id,
            branchen: [],
            solutions: [],
            model_series: [],
            countries: [],
            bodybuilder: [],
          },
          {
            epp: 3,
            page_number: 0,
          }
        ),
      ]);
      this.isSearching = false;

      this.products = result[0].resultList.sort((a: Product, b: Product) => {
        return a.name.localeCompare(b.name);
      });
      this.bodybuilders = result[1].resultList.sort(
        (a: BodyBuilder, b: BodyBuilder) => {
          return a.name.localeCompare(b.name);
        }
      );
    }
  }

  public onSaveCurrentSearch() {
    if (this.lastQueries.includes(this.searchQuery)) {
      return;
    }

    let queries = this.lastQueries.slice(0, 2);
    queries.unshift(this.searchQuery);

    localStorage.setItem(
      "conversionworld.search.lastQueries",
      JSON.stringify(queries)
    );
    this.lastQueries = queries;
  }

  public onLastQueryClick(query, event) {
    event.preventDefault();
    this.searchQuery = query;
  }

  public onExtendedSearch(tab = "solution") {
    if (this.products.length <= 0) {
      return;
    }
    this.onSaveCurrentSearch();
    window.location.href =
      "/" +
      this.language +
      "/" +
      this.country +
      "/suche/" +
      this.searchQuery +
      "#" +
      tab;
  }
}
